let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4muy4")).then(() => parcelRequire('af0Hy'));